import { createElement } from "react";
import './index.scss';
const ColorfulCol = function ColorfulRow({ width, children, ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: `au-col-${width}`, ..._otherProps }, children));
};
ColorfulCol.displayName = 'ColorfulCol';
export default ColorfulCol;
